import { render, staticRenderFns } from "./Animation.vue?vue&type=template&id=2d8835db&scoped=true&"
import script from "./Animation.vue?vue&type=script&lang=ts&"
export * from "./Animation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8835db",
  null
  
)

export default component.exports